import React from 'react'
import { DaliAddressMode } from '../types/dimmingProfile.types'
import { DaliAddressValue } from '../utils/daliAddress'
import { DimmingProfileUiStrings } from '../i18n/dimmingProfileI18n'

interface DaliAddressSelectorProps {
  value: DaliAddressValue
  addressByte: number
  onModeChange: (mode: DaliAddressMode) => void
  onIdChange: (id: number) => void
  strings: DimmingProfileUiStrings
  disabled?: boolean
}

const MODE_ORDER: DaliAddressMode[] = [
  'all',
  'broadcast',
  'analog',
  'single',
  'group',
]

const inputStyle: React.CSSProperties = {
  height: 28,
  padding: '2px 6px',
  border: '1px solid #d1d5db',
  borderRadius: 4,
  fontSize: 13,
  color: '#1f2937',
}

// DALI address selector: mode dropdown + optional id input for single/group.
const DaliAddressSelector: React.FC<DaliAddressSelectorProps> = ({
  value,
  addressByte,
  onModeChange,
  onIdChange,
  strings,
  disabled = false,
}) => {
  const idMax = value.mode === 'group' ? 15 : 63
  const idLabel = value.mode === 'group' ? strings.daliGroupId : strings.daliSingleId

  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 12,
      }}
    >
      <label style={{ display: 'flex', flexDirection: 'column', gap: 4, fontSize: 13, fontWeight: 600, color: '#374151' }}>
        {strings.daliAddress}
        <select
          disabled={disabled}
          value={value.mode}
          onChange={(e) => onModeChange(e.target.value as DaliAddressMode)}
          style={inputStyle}
        >
          {MODE_ORDER.map((mode) => (
            <option key={mode} value={mode}>
              {strings.daliMode[mode]}
            </option>
          ))}
        </select>
      </label>

      {(value.mode === 'single' || value.mode === 'group') && (
        <label style={{ display: 'flex', flexDirection: 'column', gap: 4, fontSize: 13, fontWeight: 600, color: '#374151' }}>
          {idLabel}
          <input
            type="number"
            min={0}
            max={idMax}
            disabled={disabled}
            value={value.id}
            onChange={(e) => {
              const n = parseInt(e.target.value, 10)
              onIdChange(Number.isNaN(n) ? 0 : Math.min(idMax, Math.max(0, n)))
            }}
            style={{ ...inputStyle, width: 80 }}
          />
        </label>
      )}

      <span style={{ fontSize: 12, color: '#6b7280', alignSelf: 'flex-end' }}>
        0x{addressByte.toString(16).toUpperCase().padStart(2, '0')}
      </span>
    </div>
  )
}

export default DaliAddressSelector
